export const getApprovalFileId = (item) => {
  if (item.uploaded_file_id) return item.uploaded_file_id;
  if (typeof item.id === "string" && item.id.startsWith("unorganized-")) {
    return item.id.replace("unorganized-", "");
  }
  return item.id;
};
